import React from "react";
import {
    Box
} from "@chakra-ui/react";
import { PrismicRichText } from "@prismicio/react";

const RichTextSlice = ({ slice }) => {
    console.log(slice);
    return (
        <Box my="12">
            <PrismicRichText field={slice.primary.content.richText} />
        </Box>
    );
}

export default RichTextSlice;